import { render, staticRenderFns } from "./SettingsContentWrapper.vue?vue&type=template&id=03b4d880"
import script from "./SettingsContentWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsContentWrapper.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports